import { render } from "./RemoveBg.vue?vue&type=template&id=015bef78&scoped=true"
import script from "./RemoveBg.vue?vue&type=script&lang=js"
export * from "./RemoveBg.vue?vue&type=script&lang=js"

import "./RemoveBg.vue?vue&type=style&index=0&id=015bef78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015bef78"]])

export default __exports__